<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <navigation-drawer/>
        <router-view/>
    </div>
</template>

<script>
    import NavigationDrawer from '@/components/navigation-drawer'

    export default
    {
        name: 'account',
        components:
        {
            NavigationDrawer
        }
    }
</script>